<template>
  <v-container>
    <v-layout mt-5 xs8>
      <v-flex column wrap xs12 sm12 md11 lg10 xl10>
        <h3>
          <v-icon large color="yellow">gavel</v-icon>
          Evident Extranet @ Maintenance
        </h3>
        <p>
          The Evident Extranet is currently not available due to maintenance.
        </p>
        <p v-if="maintenanceMessage">
          {{ maintenanceMessage }}
        </p>
        <blockquote>
          Please come back
          <span v-if="maintenanceDateEnd">
            after {{ maintenanceDateEnd.toLocaleString("en-GB") }}
          </span>
          <!--
          -->
          <span v-else>later</span>
          <!--
          -->
          .
        </blockquote>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("admin", {
      maintenanceDateEnd: "getMaintenanceDateEnd",
      maintenanceMessage: "getMaintenanceMessage"
    })
  }
};
</script>
